module.exports = __webpack_public_path__ + "static/sp-about-4465963ae379da7d58f6775b898e0860.jpg";